/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Frame_Rate_HelpInputs */

const en_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Target frame rate`)
};

const fr_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequence d'images cible`)
};

const de_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zielbildrate`)
};

const it_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequenza dei fotogrammi di destinazione`)
};

const ru_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Целевая частота кадров`)
};

const es_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Velocidad de fotogramas objetivo`)
};

const zh_cn2_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目标帧率`)
};

const ja_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目標フレームレート`)
};

const hi_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लक्ष्य फ्रेम दर`)
};

const pt_pt2_embed_captions_frame_rate_help = /** @type {(inputs: Embed_Captions_Frame_Rate_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Taxa de quadros alvo`)
};

/**
* | output |
* | --- |
* | "Target frame rate" |
*
* @param {Embed_Captions_Frame_Rate_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_frame_rate_help = /** @type {((inputs?: Embed_Captions_Frame_Rate_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Frame_Rate_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_frame_rate_help(inputs)
	if (locale === "de") return de_embed_captions_frame_rate_help(inputs)
	if (locale === "it") return it_embed_captions_frame_rate_help(inputs)
	if (locale === "ru") return ru_embed_captions_frame_rate_help(inputs)
	if (locale === "es") return es_embed_captions_frame_rate_help(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_frame_rate_help(inputs)
	if (locale === "ja") return ja_embed_captions_frame_rate_help(inputs)
	if (locale === "hi") return hi_embed_captions_frame_rate_help(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_frame_rate_help(inputs)
	return en_embed_captions_frame_rate_help(inputs)
});